"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _colors = require("@material-ui/core/colors");

var _styles = require("@material-ui/core/styles");

var _ACLHeaderToggleButton = _interopRequireDefault(require("./ACLHeaderToggleButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: 4,
      paddingLeft: 24,
      paddingRight: 4,
      marginTop: 0,
      backgroundColor: _colors.grey[200],
      borderTop: "solid 1px ".concat(theme.palette.divider)
    }
  };
});

var ACLHeader = function ACLHeader(_ref) {
  var header = _ref.header,
      acl = _ref.acl,
      onAclChange = _ref.onAclChange,
      labels = _ref.labels;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h8",
    color: "inherit"
  }, header), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flexGrow: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_ACLHeaderToggleButton["default"], {
    acl: acl,
    onAclChange: onAclChange,
    labels: labels.acl
  }));
};

var _default = ACLHeader;
exports["default"] = _default;